/* eslint-disable no-unused-vars */
import React from 'react';
import { Typography, FormControl, FormHelperText, InputAdornment, OutlinedInput } from '@mui/material';
import { makeStyles } from '@mui/styles';
import './styles.scss';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: '100%',
  },
  errorRed: {
    color: '#f44336',
  },
  Input: {
    '& .MuiInputBase-inputSizeSmall': {
      padding: theme?.spacing(1, 1.5),
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-root:hover .MuiInputBase-inputSizeSmall': {
      borderColor: '#B72755',
    },
    '& .MuiFormHelperText-marginDense': {
      margin: theme?.spacing(0.5, 0.5, 0, 0.5),
    },
    '& .MuiOutlinedInput-inputAdornedEnd': {
        paddingTop: '10.5px',
        paddingBottom: '10.5px',
    },
    '& .MuiInputAdornment-root': {
        height: theme.spacing(2.56),
        display: 'flex',
        maxHeight: theme.spacing(3),
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    '& .MuiInputAdornment-root .MuiInputAdornment-positionEnd': {
        padding: theme.spacing(10),
        backgroundColor: '#eeeeee',
        border: theme.spacing('0px 4px 4px 0px'),
    },
  },
}));

export default function InlineInputAdornment(props) {
  const {
    name, value, label, required, currency, placeholder, variant = 'outlined', error = null, size = 'small', fullWidth, type = '', onChange, onKeyPress, ...others
  } = props;
  const classes = useStyles();

  return (
    <FormControl variant={variant} className={classes.formControl}>
      {label &&
      <Typography
        component="p"
        className={required ? 'inputLabel required' : 'inputLabel'}
      >{label}
      </Typography>}
      <OutlinedInput
        placeholder={placeholder}
        variant="outlined"
        name={name}
        onChange={onChange}
        onKeyDown={onKeyPress}
        type={type}
        size={size}
        id="outlined-adornment-weight"
        endAdornment={<InputAdornment position="end">{currency}</InputAdornment>}
        aria-describedby="outlined-weight-helper-text"
        inputProps={{
          'aria-label': 'weight',
        }}
        value={value}
        {...others}
        {...(error && { error: true, helperText: error })}
        className={classes?.Input}
      />
      <FormHelperText className={classes.errorRed}>{error && error}</FormHelperText>
      {/* <FormHelperText>{error && error}</FormHelperText> */}
    </FormControl>
  );
}
